import { PaytrieAPI } from '@paytrie/client'

export type OtcRequest = PaytrieAPI.OtcRequest
export type OtcWireInstructions = PaytrieAPI.OtcWireInstructions

export type CreateOtcRequestInput = Omit<
  PaytrieAPI.CreateOtcRequest,
  'leftSideLabel' | 'rightSideLabel'
> & {
  leftSideLabel: string
  rightSideLabel: string
}

const requestFailed = (status: number): Error =>
  Object.assign(new Error(`Request failed with status ${status}`), { status })

export async function createOtcRequest(
  input: CreateOtcRequestInput
): Promise<OtcRequest> {
  const response = await PaytrieAPI.createOtcRequest({
    ...input,
    leftSideLabel:
      input.leftSideLabel as PaytrieAPI.CreateOtcRequestLeftSideLabel,
    rightSideLabel:
      input.rightSideLabel as PaytrieAPI.CreateOtcRequestRightSideLabel,
  })
  if (response.status === 201 && response.data.success) {
    return response.data.data
  }
  throw requestFailed(response.status)
}

export async function getOtcRequest(id: string): Promise<OtcRequest> {
  const response = await PaytrieAPI.getOtcRequest(id)
  if (response.status === 200 && response.data.success) {
    return response.data.data
  }
  throw requestFailed(response.status)
}

export async function listOtcRequests(): Promise<OtcRequest[]> {
  const response = await PaytrieAPI.listOtcRequests()
  if (response.status === 200 && response.data.success) {
    return response.data.data.items
  }
  throw requestFailed(response.status)
}

export async function getWireInstructions(): Promise<OtcWireInstructions> {
  const response = await PaytrieAPI.getOtcWireInstructions()
  if (response.status === 200 && response.data.success) {
    return response.data.data
  }
  throw requestFailed(response.status)
}
